import LegalShell from "./LegalShell";

export default function Privacy() {
  return (
    <LegalShell eyebrow="Privacy Policy" title="Your photo. Your data. On your terms.">
      <p>
        StyleMe ("we", "us") respects your privacy. This Privacy Policy explains what we collect,
        how we use it, and the choices you have. By using stylenme.com you agree to the practices
        described here.
      </p>

      <h2>1. What we collect</h2>
      <ul>
        <li><b>Account data:</b> name, email, hashed password.</li>
        <li><b>Optional profile inputs:</b> gender, body shape, height, weight, skin tone — used solely to personalise recommendations.</li>
        <li><b>Generated content:</b> AI-styled previews of your portrait (so you can revisit your looks).</li>
        <li><b>Payment metadata:</b> Razorpay order ID, plan, status. Card details never touch our servers — Razorpay handles them.</li>
        <li><b>Basic telemetry:</b> minimal analytics to keep the app healthy.</li>
      </ul>

      <h2>2. What we do NOT store</h2>
      <ul>
        <li>
          <b>Your uploaded photo.</b> The portrait you upload is processed in real time by our AI pipeline
          and is permanently deleted from our servers immediately after the styled preview is generated.
          We never persist the original photo.
        </li>
        <li>Credit / debit card numbers, CVV, or banking PINs.</li>
      </ul>

      <h2>3. How we use the data</h2>
      <ul>
        <li>To generate your styled looks and remember them across sessions.</li>
        <li>To bill the right plan and provide subscription benefits.</li>
        <li>To improve the product — only in aggregate, never tied to your identity.</li>
        <li>To send transactional emails (password reset, billing receipts). We don't send marketing email without your consent.</li>
      </ul>

      <h2>4. Who we share data with</h2>
      <p>Strictly limited to processors that help us run the service:</p>
      <ul>
        <li><b>Razorpay</b> — payment processing.</li>
        <li><b>Google (Gemini)</b> — AI image generation for the styled preview (your photo is forwarded once, in memory, and is not retained by us).</li>
        <li><b>Resend</b> — transactional email delivery (only your email address and the email contents).</li>
        <li><b>MongoDB Atlas-compatible hosting</b> — secure storage of account + generated previews.</li>
      </ul>

      <h2>5. Your rights</h2>
      <ul>
        <li><b>Access</b> — write to us at <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a> and we'll send you a copy of your data.</li>
        <li><b>Delete</b> — request full account deletion at the same address; we honour requests within 7 business days.</li>
        <li><b>Portability</b> — receive your data in JSON.</li>
        <li><b>Withdraw consent</b> — for non-essential processing at any time.</li>
      </ul>

      <h2>6. Security</h2>
      <p>
        All traffic is encrypted with TLS. Passwords are stored as bcrypt hashes.
        Production secrets are managed via environment variables, never in source code.
        We will notify affected users within 72 hours of a confirmed breach.
      </p>

      <h2>7. Children</h2>
      <p>
        StyleMe is intended for users 18+. If you believe a minor has created an account, please notify us and we will remove it.
      </p>

      <h2>8. Changes</h2>
      <p>
        We may update this policy. Material changes will be announced on this page and, where appropriate,
        notified by email.
      </p>

      <h2>9. Contact</h2>
      <p>
        Privacy questions or requests: <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a>.
      </p>
    </LegalShell>
  );
}
